import { Link } from "react-router-dom";
import Page from "../components/page";
import { useEffect, useState } from "react";
import moment from "moment";
import api from "../functions/api";
import groupBy from "lodash.groupby";

const Attendance = () => {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [attendance, setAttendance] = useState(null);

    const getAttendance = async () => {
        try {
            let data = await api.get(
                `/attendance?startDate=${startDate.toString()}&endDate=${endDate.toString()}`
            );
            data = data.map((item) => ({
                ...item,
                _createdAt: moment(new Date(item.createdAt)).format(
                    "DD/MM/YYYY"
                ),
            }));
            setAttendance(groupBy(data, "_createdAt"));
        } catch (err) {
            console.log("��� ~ getAttendance ~ err:", err);
        }
    };

    useEffect(() => {
        getAttendance();
    }, [startDate, endDate]);

    return (
        <Page title="Attendance">
            <div className="attendance">
                <div className="date">
                    <div className="start-date">
                        <label>Start Date</label>
                        <input
                            className="product"
                            type="date"
                            value={moment(startDate).format("YYYY-MM-DD")}
                            onChange={(e) =>
                                setStartDate(new Date(e.currentTarget.value))
                            }
                        />
                    </div>

                    <div className="start-date">
                        <label>End Date</label>
                        <input
                            className="product"
                            type="date"
                            value={moment(endDate).format("YYYY-MM-DD")}
                            onChange={(e) =>
                                setEndDate(new Date(e.currentTarget.value))
                            }
                        />
                    </div>
                </div>

                {Object.keys(attendance ?? []).map((item, index) => {
                    const attendances = attendance[item];
                    return (
                        <div key={index}>
                            <div className="style-4">
                                <div className="style-5">{item}</div>
                            </div>

                            {attendances?.map((item, index) => (
                                <Link
                                    to={`/attendance-details/${btoa(
                                        JSON.stringify(item)
                                    )}`}
                                    className="style-14"
                                    key={index}
                                >
                                    <div className="style-15">
                                        <div className="style-16">
                                            {item?.machineName}
                                            <div className="style-21">
                                                {item?.shift == 0
                                                    ? "DAY"
                                                    : "NIGHT"}
                                            </div>
                                        </div>

                                        <div className="style-24">
                                            {item?.employeeName}
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    );
                })}
            </div>
        </Page>
    );
};

export default Attendance;
